import { Stack, Typography } from "@mui/material"

import { getMemberLevelIcon } from "@/components/MemberBenefitBadge/MemberLevelIconMap"

interface DealBadgeProps {
  text: string
  isMemberDeal: boolean
}

export const DealBadge = ({ text, isMemberDeal }: DealBadgeProps) => {
  const icon = isMemberDeal ? getMemberLevelIcon("0") : undefined
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={"5.5px"}
      sx={{
        borderRadius: "0 0 4px 0",
        bgcolor: isMemberDeal ? "#710325" : "primary.main",
        color: "white",
        py: "8px",
        px: "12px",
      }}
    >
      {icon}
      <Typography component="span" variant="caption" fontWeight="600">
        {text}
      </Typography>
    </Stack>
  )
}
